import {useEffect, useRef, useState} from 'react';
import {useScrollTop} from '../common/hooks/useScrollTop';
import {isLogin, sendWebUvLog} from '@/utils/main';
import {sendClickLog} from '@/utils/main/my-plus/log';

export const FloatingButton = ({selectedMode, handleOnClickMode}) => {
  const {isDisplay, scrollToTop} = useScrollTop();
  const isPrefer = selectedMode === 'prefer' && isLogin();
  const clickTimer = useRef(null); // 클릭 방지 타임아웃 저장할 ref
  const [isActive, setIsActive] = useState(true);

  const handleClickToggle = () => {
    // 이미 클릭 중이면 함수 종료
    if (clickTimer.current) {
      return;
    }

    handleOnClickMode(isPrefer ? 'popular' : 'prefer');
    sendClickLog('main_list_button', {
      button_type: isPrefer ? 'list_hot' : 'list_recommend',
    });

    // 클릭 후 1.5초 동안 클릭 방지
    clickTimer.current = setTimeout(() => {
      clickTimer.current = null;
      setIsActive(true);
    }, 1500);
    setIsActive(false);
    sendWebUvLog(); // 241021 선호모드 변경 시 현재 화면 갱신 === 페이지 리로드와 동일하게 보는 관점에 의해 uv로 추가됨
  };

  return (
    <>
      <button
        type='button'
        className={`page_top ${isDisplay ? 'active' : ''}`}
        onClick={scrollToTop}>
        상단 바로가기
      </button>
      {isLogin() && (
        <button
          tip={isPrefer ? '인기 모드' : '선호 모드'}
          type='button'
          className={`${isPrefer ? 'prefer_mode' : 'popular_mode'} ${isActive ? 'active' : 'disabled'}`}
          onClick={handleClickToggle}
          disabled={!isActive} // 버튼 비활성화 제어
        >
          <span className='tooltip'>
            {isPrefer ? '인기 모드' : '선호 모드'}
          </span>
        </button>
      )}
    </>
  );
};
